"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _OldButton = _interopRequireDefault(require("../OldButton"));

var _Spacer = _interopRequireDefault(require("../Spacer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SetCouponBox(props) {
  let hasBeenSet = !!props.coupon;
  let mainColor = props?.theme?.main || "secondary";
  let bgColor = `${mainColor}.dark`;

  if (hasBeenSet) {
    if (props.workspace && props.workspace.id != "personal" && props.workspace.agreement && props.workspace.agreement.promotion_code) {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        bg: bgColor,
        p: "l",
        br: "m"
      }, /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        fs: "s",
        color: "common.white"
      }, "\u06A9\u062F \u062A\u062E\u0641\u06CC\u0641 \u06AF\u0631\u0648\u0647"), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
        size: "m"
      }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        fs: "m",
        ff: "mainBold",
        color: "common.white"
      }, props.workspace.name), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
        size: "m"
      }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        fs: "s",
        color: "common.white"
      }, "\u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u0627\u0639\u0645\u0627\u0644 \u0634\u062F\u0647 \u0627\u0633\u062A.")));
    }

    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      bg: bgColor,
      p: "l",
      br: "m"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      distribution: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      direction: "vertical",
      alignment: "end"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      fs: "s",
      color: "common.white"
    }, "\u06A9\u062F \u062A\u062E\u0641\u06CC\u0641"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      fs: "m",
      ff: "mainBold",
      color: "common.white"
    }, props.coupon)), props.loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
      size: "m"
    }), /*#__PURE__*/_react.default.createElement(_reactNative.ActivityIndicator, null))), /*#__PURE__*/_react.default.createElement(_OldButton.default, {
      onPress: props.onRemove
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
      size: "m"
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      fs: "xm",
      ff: "mainBold",
      color: "common.white"
    }, "\u062D\u0630\u0641 \u06A9\u062F")))));
  } // It should be here and after checkin "remove mode"


  if (!props.onAdd) {
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      bg: "neutrals.700",
      p: "l",
      br: "m"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      distribution: "center"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      fs: "m",
      ff: "mainBold",
      color: "common.white"
    }, "\u0627\u0645\u06A9\u0627\u0646 \u062B\u0628\u062A \u06A9\u062F \u062A\u062E\u0641\u06CC\u0641 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.")));
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: bgColor,
    p: "l",
    br: "m"
  }, /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    onPress: props.onAdd
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "m",
    ff: "mainBold",
    color: "common.white"
  }, "\u06A9\u062F \u062A\u062E\u0641\u06CC\u0641 \u062F\u0627\u0631\u06CC\u062F\u061F"), props.loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    size: "m"
  }), /*#__PURE__*/_react.default.createElement(_reactNative.ActivityIndicator, null))), /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "xm",
    ff: "mainBold",
    color: "common.white"
  }, "\u0627\u0641\u0632\u0648\u062F\u0646 \u06A9\u062F \u062A\u062E\u0641\u06CC\u0641")))));
}

var _default = SetCouponBox;
exports.default = _default;